import React from "react";
import { Navbar, Footer } from "./../../Components";
import Banner from "./../../Containers/Blog/Banner";
import ListBlog from "./../../Containers/Blog/ListBlog";
//import ForWish from "../../Containers/Faq/";
import {useLocation} from "react-router-dom";
import {useInfiniteQuery} from "react-query";
import api from "../../Services/api";
import DocumentMeta from "react-document-meta";

function Blog() {
    const meta = {
        title: ' Blog et actualités autour du vin - Vignitus',
        description: 'Découvrez toute l\'actualité autour du vin, du champagne et des spiritueux rares et convoités.',
        canonical: 'https://vignitus.fr/blog',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Vignitus, Blog, actualité, vin, champagne, spiritueux'
            }
        }
    };
    return (
        <DocumentMeta {...meta}>
            <div>
          <Navbar />
          <div className="content-wraper">
            <Banner />
            <ListBlog/>
          </div>
          <Footer />
        </div>
        </DocumentMeta>
  );
}

export default Blog;
